import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TopicRequest, TopicRequestSearch } from '../../../models/api-appointment/topic/topic.request.model';
import { TopicResponse, TopicResponseSearch } from '../../../models/api-appointment/topic/topic.response.model';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TopicService {

  constructor(private http: HttpClient) { }
  pathUrl: string = environment.backend.pathUrl.appointment.topic;
  baseUrl: string = environment.backend.baseUrl_appuntamenti;
  url: string = this.baseUrl + this.pathUrl;

  create(request: TopicRequest): Observable<TopicResponse> {
    let url = this.url;
    return this.http.post<TopicResponse>(url, request);
  }

  getEntity(id: number): Observable<TopicResponse> {
    let url = this.url +"/" + id;
    return this.http.get<TopicResponse>(url);
  }

  update(id: number, request: TopicRequest): Observable<TopicResponse> {
    let url = this.url +"/" + id;
    return this.http.put<TopicResponse>(url, request);
  }

  delete(id: number) {
    let url = this.url +"/" + id;
    return this.http.delete<any>(url);
  }

  publish(id:number,published:boolean):Observable<TopicResponse>{
    let url = this.url +"/" + id + "/publish?published="+published;
    let request = {}
    request['id'] = id;
    request['published'] = published;
    return this.http.put<TopicResponse>(url,request);
  }
  
  search(request:TopicRequestSearch):Observable<TopicResponseSearch>{
    let url = this.url +"/" +"search";
    return this.http.post<TopicResponseSearch>(url,request);
  }
}
